import Resumable from "./resumable";

export const createResumable = (targetUrl) => {
  const csrftoken = document.head.querySelector('meta[name="csrf-token"]');

  return new Resumable({
    target: targetUrl,
    chunkSize: 1 * 1024 * 1024, // 1MB
    simultaneousUploads: 1, // There are a problem with more then one simultaneous uploads so we keep it to 1
    testChunks: false,
    chunkRetryInterval: 2000,
    maxChunkRetries: 10,
    headers: {
      'X-CSRF-TOKEN': csrftoken.content,
    },
  });
}
